"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _order = require("@/api/order");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../customer/CustomerTable.vue");
var _FilterOrder = _interopRequireDefault(require("./components/FilterOrder.vue"));
var _OrderModal = _interopRequireDefault(require("./components/OrderModal.vue"));
var _OrderExcelTable = _interopRequireDefault(require("./components/OrderExcelTable.vue"));
var _ExportModal = _interopRequireDefault(require("./components/ExportModal.vue"));
var _orderExcel = require("./components/order-excel");
var _OrderTable = _interopRequireDefault(require("./OrderTable.vue"));
var _ModifyHistoryModal = _interopRequireDefault(require("./components/ModifyHistoryModal.vue"));
var _initStore = require("@/store/initStore");
var _SelectDateModal = _interopRequireDefault(require("../../components/Shared/SelectDateModal.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _order2 = require("@/types/order");
var OrderPage = /*#__PURE__*/function (_Vue) {
  function OrderPage() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "orders", []);
    (0, _defineProperty2.default)(_this, "ordersExport", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", _CustomerTable.groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "colsExport", []);
    (0, _defineProperty2.default)(_this, "exportType", null);
    (0, _defineProperty2.default)(_this, "ExportExcelType", _orderExcel.ExportExcelType);
    (0, _defineProperty2.default)(_this, "OrderType", _order2.OrderType);
    return _this;
  }
  (0, _inherits2.default)(OrderPage, _Vue);
  return (0, _createClass2.default)(OrderPage, [{
    key: "transformOrders",
    get: function get() {
      var data = [];
      data = this.orders.map(function (order) {
        var total = 0;
        order.orderDetails.forEach(function (orderDetal) {
          total += orderDetal.originPrice * orderDetal.quantity;
        });
        order.totalOriginPrice = total;
        return order;
      });
      return data;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.$route.query.staffId) {
        this.$refs.filter.date = [this.$route.query.date, this.$route.query.date];
        this.$refs.filter.form.staffId = +this.$route.query.staffId;
        this.filters.from = this.$route.query.date;
        this.filters.to = this.$route.query.date;
        this.filters.staffId = +this.$route.query.staffId;
      }
      if (this.$route.query.orderCode) {
        this.query.search = this.$route.query.orderCode;
      }
      this.fetchOrders();
    }
  }, {
    key: "created",
    value: function created() {
      _initStore.configurationStore.fetchData();
    }
  }, {
    key: "handleExportExcel",
    value: function handleExportExcel(exportType) {
      this.exportType = exportType;
      this.$refs.SelectDateModal.handleCreate();
    }
  }, {
    key: "handleSelectDateOk",
    value: function handleSelectDateOk(_ref) {
      var startDate = _ref.startDate,
        endDate = _ref.endDate;
      var from = startDate,
        to = endDate;
      switch (this.exportType) {
        case _orderExcel.ExportExcelType.Real:
          this.exportExcelReal({
            from: from,
            to: to
          });
          break;
        case _orderExcel.ExportExcelType.Accountant:
          this.exportExcelAccountant({
            from: from,
            to: to
          });
          break;
        case _orderExcel.ExportExcelType.RealPublish:
          this.exportExcelRealPublish({
            from: from,
            to: to
          });
          break;
        case _orderExcel.ExportExcelType.RealNoPublish:
          this.exportExcelRealNotPublish({
            from: from,
            to: to
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchOrders();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row, row.shopeeOrder ? "shopee" : "shopify");
    }
  }, {
    key: "handleModifyHistory",
    value: function handleModifyHistory(row) {
      this.$refs.ModifyHistoryModal.handleView(row);
    }
  }, {
    key: "fetchOrders",
    value: function fetchOrders() {
      var _this2 = this;
      this.loading = true;
      _order.orderApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters)).then(function (res) {
        _this2.orders = res.data.orders;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "fetchOrderExport",
    value: function () {
      var _fetchOrderExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var extendQuery,
          query,
          res,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              extendQuery = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters), extendQuery);
              delete query.page;
              delete query.limit;
              _context.next = 6;
              return _order.orderApi.findAll(query);
            case 6:
              res = _context.sent;
              this.ordersExport = res.data.orders;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchOrderExport() {
        return _fetchOrderExport.apply(this, arguments);
      }
      return fetchOrderExport;
    }()
  }, {
    key: "fetchOrdersAndGiveawayExport",
    value: function () {
      var _fetchOrdersAndGiveawayExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _res$data$orders;
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
              delete query.page;
              delete query.limit;
              _context2.next = 5;
              return _order.orderApi.findOrdersAndGiveaway(query);
            case 5:
              res = _context2.sent;
              this.ordersExport = (_res$data$orders = res.data.orders).concat.apply(_res$data$orders, (0, _toConsumableArray2.default)(res.data.giveaways));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchOrdersAndGiveawayExport() {
        return _fetchOrdersAndGiveawayExport.apply(this, arguments);
      }
      return fetchOrdersAndGiveawayExport;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate(type) {
      this.$refs.modal.handleCreate(type);
    }
  }, {
    key: "handleExport",
    value: function handleExport() {
      var query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
      this.$refs.export.handleView(query);
    }
  }, {
    key: "exportExcel",
    value: function () {
      var _exportExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(type, _ref2) {
        var from, to;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              from = _ref2.from, to = _ref2.to;
              this.loadingExcel = true;
              _context3.next = 4;
              return this.fetchOrderExport({
                from: from,
                to: to
              });
            case 4:
              this.loadingExcel = false;
              (0, _orderExcel.exportOrderExcel)({
                data: this.ordersExport,
                type: type,
                fromDate: (0, _moment.default)(from).format("DD.MM.YYYY"),
                toDate: (0, _moment.default)(to).format("DD.MM.YYYY")
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function exportExcel(_x, _x2) {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }()
  }, {
    key: "exportExcelReal",
    value: function exportExcelReal(_ref3) {
      var from = _ref3.from,
        to = _ref3.to;
      this.exportExcel(_orderExcel.ExportExcelType.Real, {
        from: from,
        to: to
      });
    }
  }, {
    key: "exportExcelAccountant",
    value: function exportExcelAccountant(_ref4) {
      var from = _ref4.from,
        to = _ref4.to;
      this.exportExcel(_orderExcel.ExportExcelType.Accountant, {
        from: from,
        to: to
      });
    }
  }, {
    key: "exportExcelRealPublish",
    value: function exportExcelRealPublish(_ref5) {
      var from = _ref5.from,
        to = _ref5.to;
      this.exportExcel(_orderExcel.ExportExcelType.RealPublish, {
        from: from,
        to: to
      });
    }
  }, {
    key: "exportExcelRealNotPublish",
    value: function exportExcelRealNotPublish(_ref6) {
      var from = _ref6.from,
        to = _ref6.to;
      this.exportExcel(_orderExcel.ExportExcelType.RealNoPublish, {
        from: from,
        to: to
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
OrderPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    OrderModal: _OrderModal.default,
    FilterOrder: _FilterOrder.default,
    OrderExcelTable: _OrderExcelTable.default,
    ExportModal: _ExportModal.default,
    OrderTable: _OrderTable.default,
    ModifyHistoryModal: _ModifyHistoryModal.default,
    SelectDateModal: _SelectDateModal.default
  }
})], OrderPage);
var _default = exports.default = OrderPage;